import reducer from "./reducers.js"

import * as dashboardOperations from "./operations"
import * as dashboardSelectors from "./selectors"

export { dashboardOperations, dashboardSelectors }

export default reducer
